import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  actions: {
    paddingTop: '23px',
    '& label': {
      marginLeft: '8px',
    },
  },
  actionWithRemoveButton: {
    paddingTop: '17px',
    '& label': {
      marginLeft: '8px',
    },
  },
});
